export function isIOSPlatform() {
    return "webkit" in window;
}
export function sendIOSRequest(req) {
    if (isIOSPlatform()) {
        window.webkit.messageHandlers.global.postMessage(req); // '*' ??
    }
    else {
        throw new Error("Invalid usage!!! Platform is not supported!!!");
    }
}
